import { useCallback } from 'react';
import { useWidgetTokenStore } from '@elfsight/lib-utils';
import { Form as LibForm } from '@elfsight/widget-form-builder/widget';
import { useLingui } from '@lingui/react/macro';
import { useSettings } from '@wu/widget-core';
import { useFormPopup } from '../form-popup-context';
import { getFormFunctionalitySettings } from '../utils';
import { FormLayout } from './form-layout';

const CLOSE_POPUP_ACTIONS = ['hide', 'redirect'];

export function Form() {
  const { t } = useLingui();

  const { editMode, ...settings } = useSettings();
  const widgetTokenStore = useWidgetTokenStore();
  const { closePopup } = useFormPopup();

  const formSettings = getFormFunctionalitySettings(settings);
  const { fields, submitAction } = formSettings;

  const handleFormSubmit = useCallback(() => {
    if (CLOSE_POPUP_ACTIONS.includes(submitAction)) {
      closePopup();
    }
  }, [submitAction, closePopup]);

  return (
    <LibForm
      {...formSettings}
      consentValues={[t`Yes`, t`No`]}
      fields={fields}
      widgetToken={widgetTokenStore.get()}
      onSubmitSuccessful={handleFormSubmit}
      editMode={editMode}
    >
      {/* @ts-expect-error fields, displayedFields и onSubmit передаются в FormLayout через cloneElement */}
      <FormLayout />
    </LibForm>
  );
}
